import { Directive, ElementRef, Input, OnInit, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils';

@Directive({
    selector: '[appIntlTelInput]',
    standalone: false
})
export class IntlTelInputDirective implements OnInit {
  @Input() options: any;
  private iti: any;

  constructor(private el: ElementRef, private control: NgControl) {}

  ngOnInit() {
    this.iti = intlTelInput(this.el.nativeElement, this.options || {});

    // Set initial validation state
    this.validatePhoneNumber();

    // Add value change listener
    this.el.nativeElement.addEventListener('countrychange', () => {
      this.validatePhoneNumber();
    });

    this.el.nativeElement.addEventListener('input', () => {
      this.validatePhoneNumber();
    });
  }

  @HostListener('blur')
  onBlur() {
    this.validatePhoneNumber();
  }

  private validatePhoneNumber() {
    const phoneNumber = this.iti.getNumber();
    const isValid = this.iti.isValidNumber();
    const errors = this.control.control.errors || {};

    if (!this.el.nativeElement.value) {
      delete errors.invalidPhoneNumber;
    } else if (isValid) {
      delete errors.invalidPhoneNumber;
    } else {
      errors.invalidPhoneNumber = true;
    }

    if (Object.keys(errors).length > 0) {
      this.control.control.setErrors(errors);
    } else {
      this.control.control.setErrors(null);
    }
  }
}
